
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...component]",
      function () {
        return require("private-next-pages/[...component]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...component]"])
      });
    }
  